import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AddressDto} from '@sportngin/se-commerce-sdk';
import {Observable} from 'rxjs';
import {ApiRequestOptions, CommerceApiService} from './commerce-api.service';
import {Store} from '@ngrx/store';

export type AddressMismatchReason =
  'ADDRESS_CORRECTED' | 'CITY_MISMATCH' | 'ZIP_CORRECTED';

export type AddressValidationResponse = AddressDto & {
  needsSuggestion?: true;
  mismatchReasons?: readonly AddressMismatchReason[];
  suggestedAddress?: AddressDto;
};

@Injectable()
export class AddressApiService extends CommerceApiService {
  readonly apiUrl: string;
  readonly controllerPath = 'v3/address_verification';

  constructor(
    protected http: HttpClient,
    protected store: Store,
  ) {
    super(http, store);
  }

  getUrl(path: string): string {
    return super.getUrl(this.controllerPath + path);
  }

  /**
   * Validates an address.
   */
  validateAddress(address: AddressDto): Observable<AddressValidationResponse> {
    const url = this.getUrl('/validateAddress');
    return this.POST<AddressValidationResponse>(
      url,
      address,
      this.getOptions(),
    );
  }

  /**
   * Adds X-Address-Provider header for address API requests (AWS Location).
   * Requires se-address-api CORS to allow this header in Access-Control-Allow-Headers.
   */
  protected override getOptions(
    src?: Partial<ApiRequestOptions>,
  ): ApiRequestOptions {
    const options = super.getOptions(src);
    options.headers = {
      ...options.headers,
      'X-Address-Provider': 'aws-location',
    };
    return options;
  }
}
